/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/style-prop-object */
import React, { useEffect } from 'react'
import styled from 'styled-components'
import Tracking from '../../../utils/helpers/Tracking'

const Container = styled.div`
  .c-wrap {
    max-width: 1280px;
    margin: auto;
    padding: 0 24px;
  }

  .c-lay {
    width: 100%;
  }

  .c-lay-main {
    vertical-align: top;
    text-align: left;
  }

  li {
    font-size: 14px;
  }

  ul {
    margin-top: 0;
  }

  table,
  tr,
  td {
    border: 1px solid #e0e0e3;
    border-spacing: 0;
    font-size: 14px;
    vertical-align: top;
  }

  table {
    a {
      word-break: break-all;
    }
  }

  .c-lay-main .main-title,
  .c-lay-main h2 {
    font-family: 'Source Sans Pro', Trebuchet MS, Arial, Helvetica, sans-serif;
  }

  h2 {
    font-family: 'Source Sans Pro', Trebuchet MS, Arial, Helvetica, sans-serif;
  }

  .c-lay-main .main-title {
    display: block;
    padding: 60px 0 12px 0;
    margin: 0 0 40px 0;
    font-size: 22px;
    font-weight: bold;
    text-transform: uppercase;
    color: #262626;
  }

  .main-title {
    display: inline;
    font-size: 22px;
    text-align: center;
  }

  .c-lay-main .main-title:after {
    display: block;
    content: '';
    margin: 12px auto 0 auto;
    height: 1px;
    width: 70px;
    background-color: #262626;
  }

  .c-lay-main h2 {
    padding: 16px 0 6px 0;
    font-size: 14px;
    color: #494949;
  }

  .c-lay-main td {
    padding: 5px;
  }
  .c-lay-main p {
    font-size: 14px;
    color: #494949;
    text-align: justify;
  }

  .c-lay-main p:last-child {
    padding-bottom: 60px;
  }

  .c-lay-main p.c-plist {
    padding-left: 14px;
  }

  .c-lay-main p.u-center {
    text-align: center;
  }

  .c-lay-main p,
  .c-lay-main li {
    overflow-wrap: break-word;
    word-wrap: break-word;
    -ms-word-break: break-all;
    word-break: break-all;
    word-break: break-word;
    -ms-hyphens: auto;
    -moz-hyphens: auto;
    -webkit-hyphens: auto;
    hyphens: auto;
  }

  .border-breadcrumb {
    position: absolute;
    bottom: 0;
    width: 100%;
    border-top: 2px solid #e0e0e3;
  }

  .c-breadcrumb {
    max-width: 1280px;
    padding: 3px 24px;
    list-style-type: none;
    text-align: left;
    border-top: none;
  }

  .c-breadcrumb a {
    text-decoration: none;
    color: #db0237;
  }

  .c-breadcrumb span {
    display: inline-block;
    font-weight: 400;
    padding-left: 15px;
    font-size: 12px;
    line-height: 30px;
  }

  .c-breadcrumb span:first-child:before {
    content: '';
    padding-right: 0;
  }

  .c-breadcrumb span:before {
    content: '>';
    position: relative;
    top: 2px;
    color: #e0e0e3;
    padding-right: 15px;
    font-weight: 800;
    font-size: 16px;
  }

  .table-wrapper {
    overflow-x: auto;

    th {
      background: #bdb9b9;
    }
  }
`
const DataPrivacy = () => {
  useEffect(() => {
    Tracking.PushView({ pagename: 'gtu' })
    const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)
    if (window.location.hash && isChrome) {
      setTimeout(() => {
        const urlhash = window.location.hash
        window.location.hash = ''
        window.location.hash = urlhash
      }, 300)
    }
  }, [])

  return (
    <Container>
      <div className="c-main">
        <div className="c-slice">
          <div className="c-wrap">
            <div className="c-breadcrumb">
              <span>
                <a href="/">SeLoger.com</a>
              </span>
              <span>Informations&nbsp;L&eacute;gales</span>
            </div>
            <div className="c-lay-main">
              <div className="main-title" style={{ textAlign: 'center' }}>
                <strong>POLITIQUE GÉNÉRALE&nbsp; DE PROTECTION DES DONNÉES&nbsp;</strong>

                <br />
                <strong>SITE WEB ET APPLICATIONS GROUPE SELOGER&nbsp;</strong>
              </div>
              <p>
                Digital Classifieds France, Groupe SeLoger (ci-après « DCF ») prend à cœur la protection de la vie privée et des données personnelles de ses utilisateurs (ci-après
                les “Utilisateurs”).
              </p>
              <p>
                La présente politique de confidentialité a pour objectif de vous informer de manière transparente sur les traitements de vos données personnelles par DCF et sur
                l’étendue de vos droits dans le cadre de l’utilisation des sites Internet&nbsp;
              </p>
              <ul>
                <li>
                  <strong>seloger.com et edito.seloger.com</strong>
                </li>
                <li>
                  <strong>selogerneuf.com</strong>
                </li>
                <li>
                  <strong>selogerconstruire.com</strong>
                </li>
                <li>
                  <strong>bellesdemeures.com</strong>
                </li>
                <li>
                  <strong>seloger-bureaux-commerces.com</strong>
                </li>
              </ul>
              <p>(ci-après « le Site Internet ») et de l’application associée le cas échéant (ci-après « l’Application »).</p>
              <p style={{ textAlign: 'justify' }}>
                <strong>IDENTITÉ DU RESPONSABLE DE TRAITEMENT</strong>
              </p>
              <p style={{ textAlign: 'justify' }}>
                DCF (Groupe SeLoger) - S.A.S, ayant son siège social au 65, rue Ordener 75018 Paris, immatriculée au RCS de Paris sous le numéro 789 177 391 - est responsable de
                traitement des données personnelles collectées sur le Site Internet et l'Application au sens du Règlement UE 2016/679 du 27 avril 2016 relatif à la protection des
                personnes physiques à l'égard du traitement des données à caractère personnel et à la libre circulation de ces données (ci-après « RGPD »).
              </p>
              <p style={{ textAlign: 'justify' }}>
                <strong>1. Qu’est-ce qu’une donnée personnelle ?</strong>
              </p>
              <p style={{ textAlign: 'justify' }}>
                Une donnée personnelle désigne toute information relative à une personne physique permettant de l’identifier directement tels que son nom, son prénom, son adresse
                postale ou e-mail, ou indirectement tel qu’un identifiant Utilisateur, une adresse IP, des données de navigation, etc.
              </p>
              <p style={{ textAlign: 'justify' }}>
                <strong>2. Quelles données collectons-nous et dans quelles circonstances ?</strong>
              </p>
              <p style={{ textAlign: 'justify' }}>DCF collecte les données suivantes vous concernant dans le cadre des activités et contextes suivants:</p>
              <ul>
                <li>Données que vous nous communiquez directement lors du remplissage d’un formulaire ou de la création d’un compte.</li>
                <li>Données de navigation collectées automatiquement lors de votre utilisation du Site Internet ou de l’Application SeLoger.</li>
                <li>
                  Données fournies par nos partenaires. Dans ce cadre, nous demandons expressément et contractuellement à notre partenaire de nous fournir la base légale adéquate
                  afin que ce dernier puisse nous fournir vos données.
                </li>
                <li>
                  Données relatives aux caractéristiques de biens immobiliers vendus fournies par nos clients, professionnels de l’immobilier ayant souscrit une offre de
                  publication d’annonces auprès de DCF ou mises à disposition grâce à la base DVF (Demande de Valeur Foncière) rendue accessible par le gouvernement.&nbsp;
                </li>
              </ul>
              <div>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <strong>Finalités</strong>
                      </td>
                      <td>
                        <strong>Site Internet / Application</strong>
                      </td>
                      <td>
                        <strong>Données collectées</strong>
                      </td>
                    </tr>
                    <tr>
                      <td rowSpan="4">
                        <strong>Gestion de votre compte</strong>
                      </td>
                      <td className="sites" rowSpan="3">
                        seloger.com&nbsp;
                      </td>
                      <td>
                        Lors de la <strong>création de votre compte</strong>, vous nous communiquez vos données de création de compte (adresse email et mot de passe créé) et nous
                        générons un identifiant unique afin de vous permettre de vous authentifier, de personnaliser votre expérience et de vous envoyer des emails de service
                        (création de compte, demande de modification de mot de passe,...).&nbsp;Si vous le souhaitez, vous pouvez également renseigner les informations personnelles
                        facultatives suivantes afin de personnaliser votre expérience sur le Site Internet et l’Application:
                        <ul>
                          <li>état civil,</li>
                          <li>numéro de téléphone,</li>
                          <li>année de naissance,</li>
                          <li>adresse postale,</li>
                          <li>raison de présence sur SeLoger</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Vous pouvez ajouter et consulter dans votre<strong> espace personnel&nbsp;</strong>
                        <ul>
                          <li>vos favoris,&nbsp;</li>
                          <li>vos recherches enregistrées</li>
                          <li>&nbsp;et vos annonces déposées.&nbsp;</li>
                        </ul>
                        Par ailleurs, vos données de navigation relatives à la consultation des pages de biens sont collectées automatiquement afin de répertorier les annonces que
                        vous avez vues précédemment.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Lors de la <strong>certification de votre profil locataire via SeLoger pass</strong>, vous nous communiquez les données suivantes afin de de vérifier la
                        validité votre pièce d'identité avec l'aide d'un sous-traitant spécialiste de la vérification et la sécurisation de documents:
                        <ul>
                          <li>état civil,</li>
                          <li>date de naissance,</li>
                          <li>adresse email,</li>
                          <li>justificatif officiel d'identité.</li>
                        </ul>
                        Vos données sont susceptibles d'être traitées à des fins d'amélioration de la performance du service sur la base de notre intérêt légitime.
                      </td>
                    </tr>
                    <tr>
                      <td>seloger-bureaux-commerces.com</td>
                      <td>
                        Lorsque vous êtes un professionnel et que vous créez un compte, vous nous communiquez les informations suivantes afin de vous permettre de vous
                        authentifier, de publier vos coordonnées sur notre annuaire et permettre aux Utilisateurs non-professionnels de l’immobilier de vous contacter dans le cadre
                        d’un projet immobilier:
                        <ul>
                          <li>état civil.</li>
                          <li>nom de société, SIRET.</li>
                          <li>Profession.</li>
                          <li>adresse mail, mot de passe créé (données d’identification).</li>
                          <li>région, département.</li>
                          <li>adresse postale.</li>
                          <li>numéro de téléphone/fax.</li>
                          <li>site web facultatif.</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td rowSpan="3">
                        <strong>Gestion de vos alertes et de votre abonnement à la newsletter</strong>
                      </td>
                      <td rowSpan="2">
                        seloger.com
                        <br />
                        edito.seloger.com
                        <br />
                        selogerneuf.com
                        <br />
                        bellesdemeures.com
                        <br />
                        seloger-bureaux-commerces.com
                        <br />
                        seloger.com
                        <br />
                        selogerneuf.com
                        <br />
                        bellesdemeures.com
                        <br />
                        seloger-bureaux-commerces.com
                      </td>
                      <td>
                        Lorsque vous vous inscrivez à une <strong>newsletter</strong> d’un Site Internet ou Application, vous nous communiquez votre adresse email afin de recevoir
                        cette newsletter.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Lorsque vous activez une alerte ou remplissez un formulaire de prise de contact avec un professionnel de l’immobilier ou d’information pour un programme
                        immobilier sans vous opposer à l’envoi d’alerte emails pour des Annonces Similaires, vous nous communiquez les données suivantes afin de recevoir par email
                        ou notification des alertes pour des biens similaires correspondant à vos critères de recherche,:
                        <ul>
                          <li>état civil,</li>
                          <li>adresse email, numéro de téléphone,</li>
                          <li>critères de recherche, titre et motif de l’alerte (facultatif).</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>selogerneuf.com</td>
                      <td>
                        Lorsque vous cochez la case <strong>“Recevoir les offres de nos partenaires"</strong> de ce formulaire, vos critères de recherche sont transmis à des
                        professionnels de l’immobilier, clients de DCF, qui pourront vous proposer des biens similaires à votre recherche.
                      </td>
                    </tr>
                    <tr>
                      <td rowSpan="18">
                        <strong>Gestion de vos demandes et de la mise en relation avec des professionnels de l’immobilier via les formulaires en ligne</strong>
                      </td>
                      <td rowSpan="4">
                        seloger.com
                        <br />
                        selogerneuf.com
                        <br />
                        bellesdemeures.com
                        <br />
                        seloger-bureaux-commerces.com
                      </td>
                      <td>
                        Lorsque vous remplissez le
                        <strong>formulaire de prise de contact avec un professionnel de l’immobilier via une page d’Annonce ou une page de l’Annuaire</strong>, vous nous
                        communiquez les informations suivantes afin de transmettre votre demande au professionnel de l’immobilier
                        <ul>
                          <li>état civil,</li>
                          <li>adresse mail, numéro de téléphone,</li>
                          <li>critères de recherche,&nbsp; titre et motif de l’alerte,</li>
                          <li>message.</li>
                        </ul>
                        Sauf opposition de votre part, vous recevrez également par mail ou par notification des<strong> biens similaires</strong> correspondant à vos critères de
                        recherches ainsi que nos propositions de services autour de votre projet immobilier (que nous qualifions de Services Analogues).
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Sous réserve de votre consentement, nous collectons certaines données de navigation (nombre de demandes de contacts associées à votre adresse mail et pages
                        visitées) afin de permettre au professionnel de l’immobilier de
                        <strong>
                          mieux comprendre votre projet immobilier d’achat, d’estimer automatiquement le degré d’intérêt de votre recherche et communiquer cette indication au
                          professionnel de l’immobilier pour l’aider à améliorer sa gestion des demandes de contact, et d’indiquer au professionnel de l’immobilier les annonces qui
                          pourraient vous intéresser.
                        </strong>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Lorsque vous remplissez le formulaire de contact <strong>“Nous contacter”, </strong>vous communiquez à notre service client les informations suivantes afin
                        de répondre à vos questions:
                        <ul>
                          <li>nom,</li>
                          <li>adresse mail,&nbsp;</li>
                          <li>objet de votre demande,</li>
                          <li>message,</li>
                          <li>statut client/non client,</li>
                          <li>code postal et ville (facultatif)</li>
                          <li>numéro de téléphone (facultatif),</li>
                          <li>nom de l’entreprise (facultatif),</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Lorsque vous remplissez certains de nos formulaires et sauf opposition de votre part, vous nous communiquez les informations suivantes afin de vous
                        recontacter par mail dans le cadre<strong> d'enquêtes de satisfaction, études et sondages:</strong>
                        <ul>
                          <li>nom,</li>
                          <li>adresse mail.</li>
                          <li>Gestion de votre navigation et de vos recherches immobilières</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td rowSpan="7">seloger.com&nbsp;</td>
                      <td>
                        Lorsque vous remplissez le<strong> formulaire de prise de contact avec un particulier louant un bien</strong>, vous nous communiquez les informations
                        suivantes afin de transmettre votre demande au loueur&nbsp;
                        <ul>
                          <li>état civil,</li>
                          <li>adresse mail, numéro de téléphone,</li>
                          <li>habitudes de vie, situation familiale.</li>
                        </ul>
                        Afin de transmettre les éléments à déclarer par le candidat à la location permettant au loueur d'apprécier sa situation financière, vous nous communiquez
                        des informations&nbsp;
                        <ul>
                          <li>sur la constitution de votre foyer,&nbsp;</li>
                          <li>votre situation professionnelle,&nbsp;</li>
                          <li>vos revenus et vos garants éventuels&nbsp;</li>
                          <li>ainsi que celles de vos colocataires.</li>
                        </ul>
                        Vous êtes également susceptibles de nous communiquer les informations relatives à la <strong>certification de votre profil locataire</strong>.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Lorsque vous remplissez le formulaire de <strong>demande d’estimation d’un bien immobilier</strong>, vous nous communiquez les informations suivantes afin
                        que nous réalisions une estimation automatisée de votre bien à l’aide de notre filiale Falguière Conseil :
                        <ul>
                          <li>état civil,</li>
                          <li>adresse mail, numéro de téléphone,</li>
                          <li>caractéristiques du bien à estimer,</li>
                          <li>profil vendeur.</li>
                        </ul>
                        De plus, sauf opposition de votre part, nous pouvons utiliser ces données pour vous recontacter par téléphone, SMS ou Emails afin de vous proposer des
                        services d'accompagnement autour de votre projet immobilier.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Lorsque vous remplissez le formulaire de <strong>Contact Acquéreur</strong> (“Besoin de l'aide d'un pro pour vous aider à définir votre projet ?”), vous
                        nous communiquez les informations suivantes afin de nous transmettions votre demande de contact à une sélection de professionnels de l’immobilier dans le
                        cadre de votre projet d’achat d’un bien immobilier :
                        <ul>
                          <li>état civil,</li>
                          <li>adresse mail, numéro de téléphone,</li>
                          <li>code postal.</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Lorsque vous remplissez le formulaire <strong>Opportunité Mandat</strong> (“Demander à être rappelé par un conseiller SeLoger”), vous nous communiquez les
                        informations suivantes afin que nous transmettions votre demande de contact à une sélection de professionnels de l’immobilier dans le cadre de votre projet
                        de vente d'un bien immobilier:
                        <ul>
                          <li>état civil,</li>
                          <li>type et localisation du bien,</li>
                          <li>adresse mail, numéro de téléphone.</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Lorsque vous remplissez un<strong> formulaire d’assurance de prêt en lien avec notre partenaire dédié</strong>, vous nous communiquez les informations
                        suivantes afin d’obtenir un devis automatisé d’assurance de prêt par notre partenaire et, si vous y consentez, afin d'être recontacté par mail par notre
                        partenaire pour affiner votre tarif d'assurance de prêt:
                        <ul>
                          <li>état civil,</li>
                          <li>adresse mail, numéro de téléphone,</li>
                          <li>caractéristiques du projet immobilier,</li>
                          <li>âge, statut professionnel, statut “fumeur”,</li>
                          <li>caractéristiques du crédit envisagé.</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Lorsque vous remplissez le <strong>formulaire de déménagement en lien avec notre partenaire dédié</strong>, vous nous communiquez les informations suivantes
                        afin d'obtenir un devis automatisé de déménagement par notre partenaire dédié:
                        <ul>
                          <li>état civil,</li>
                          <li>numéro de téléphone,</li>
                          <li>caractéristiques du déménagement.</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Lorsque vous remplissez le formulaire de <strong>signalement d'une annonce</strong>, vous nous communiquez les informations suivantes afin de prendre en
                        compte votre signalement d'une annonce et vous informer des suites données:
                        <ul>
                          <li>nom,</li>
                          <li>adresse mail,</li>
                          <li>raison du signalement,</li>
                          <li>précisions facultatives.</li>
                          <li>De plus, nous collectons votre adresse IP afin de vérifier et détecter toute tentative de signalement malveillant.</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>bellesdemeures.com</td>
                      <td>
                        Lorsque vous remplissez le formulaire de demande d’estimation et de vente d’un bien immobilier (
                        <strong>“Vous envisagez de vendre un bien immobilier de luxe ?</strong>”) , vous nous communiquez les informations suivantes afin d’être recontacté par
                        téléphone pour affiner l’estimation de votre bien et vous aider à vendre rapidement votre bien de prestige grâce à notre réseau d'agences partenaires, sous
                        réserve de votre consentement :
                        <ul>
                          <li>état civil,</li>
                          <li>adresse mail, numéro de téléphone,</li>
                          <li>caractéristiques du bien immobilier (type, surface, localisation et facultativement, adresse et descriptif),</li>
                          <li>information sur votre projet de vente.</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td rowSpan="3">seloger-bureaux-commerces.com</td>
                      <td>
                        Lorsque vous cochez la case <strong>“Confier ma demande à d’autres agences”</strong> du formulaire de contact d’une Agence,&nbsp;
                        <ul>
                          <li>vos coordonnées&nbsp;</li>
                          <li>et critères de recherche&nbsp;</li>
                        </ul>
                        sont transmis à des professionnels de l’immobilier, clients de DCF, qui sont susceptibles de vous recontacter pour vous proposer des biens similaires à
                        votre recherche.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Lorsque vous remplissez le formulaire de <strong>Contact Preneur </strong>(“Confiez votre recherche”), vous nous communiquez les informations suivantes afin
                        que nous transmettions votre demande de contact à une sélection de professionnels de l’immobilier dans le cadre de votre projet de recherche d’un bien:
                        <ul>
                          <li>type de transaction (location, cession de baux, vente ou vente de fonds de commerce).</li>
                          <li>type de bien recherché, surface pour la vente, la location et la cession de baux.</li>
                          <li>activité envisagée, effectif pour la vente, la location et la cession de baux.</li>
                          <li>secteur d’activité du fonds de commerce recherché.</li>
                          <li>lieu.</li>
                          <li>date d’installation envisagée.</li>
                          <li>commentaires facultatifs.</li>
                          <li>état civil.</li>
                          <li>adresse mail, numéro de téléphone.</li>
                          <li>nom de société.</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Lorsque vous remplissez le formulaire <strong>Opportunité Mandat </strong>(“Diffusez votre annonce”), vous nous communiquez les informations suivantes afin
                        que nous transmettions votre demande de contact à une sélection de professionnels de l’immobilier dans le cadre de votre projet de vente d'un bien
                        immobilier:
                        <ul>
                          <li>type de transaction (location, cession de baux, vente ou vente de fonds de commerce).</li>
                          <li>type de bien recherché, surface pour la vente, la location et la cession de baux.</li>
                          <li>activité envisagée, effectif pour la vente, la location et la cession de baux.</li>
                          <li>secteur d’activité du fonds de commerce recherché.</li>
                          <li>prix ou loyer du bien.</li>
                          <li>lieu.</li>
                          <li>description du bien.</li>
                          <li>état civil.</li>
                          <li>adresse mail, numéro de téléphone.</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td rowSpan="3">selogerneuf.com</td>
                      <td>
                        Lorsque vous remplissez le<strong> formulaire d’investissement</strong> (“Votre projet d’investissement immobilier sur mesure”), vous nous communiquez les
                        informations suivantes afin de nous transmettions votre demande de contact à nos partenaires spécialisés pour gérer votre demande de projet d'investissement
                        :
                        <ul>
                          <li>informations sur votre projet (objet, type de bien, localisation, critères de proximité),</li>
                          <li>informations sur votre profil (situation financière, situation familiale),</li>
                          <li>choix des partenaires à contacter,</li>
                          <li>nom,</li>
                          <li>adresse mail, numéro de téléphone,</li>
                          <li>date de naissance,</li>
                          <li>code postal.</li>
                        </ul>
                        Sauf opposition de votre part, nous pourrons également vous recontacter par téléphone ou emails afin de
                        <strong>
                          pré-qualifier votre demande de projet d'investissement et transmettre vos informations à nos partenaires sélectionnés sous réserve de votre consentement
                          préalable.
                        </strong>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Lorsque vous remplissez un formulaire sur la page d’un programme immobilier ou via l’Annuaire
                        <strong> (“Recevoir la brochure”, “Recevoir le plan” ou “Contacter le Promoteur”)</strong>, vous nous communiquez les informations suivantes afin de
                        transmettre votre demande au promoteur immobilier:
                        <ul>
                          <li>nom,</li>
                          <li>adresse mail, numéro de téléphone,</li>
                          <li>critères de recherche, titre et motif de l’alerte.</li>
                        </ul>
                        Dans le cadre de ces formulaires, vous pouvez également consentir à l’envoi d’offres de promoteurs immobiliers de SeLoger Neuf par SMS et/ou Email selon vos
                        préférences (“Recevoir les offres des promoteurs de SeLoger neuf par SMS / Email”).
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Lorsque que vous appuyez sur le bouton “Appeler” en ligne un promoteur immobilier, nous générons un identifiant technique afin d’
                        <strong>appeler en VoIP le promoteur immobilier.</strong>
                      </td>
                    </tr>
                    <tr>
                      <td rowSpan="6">
                        <strong>Gestion de votre navigation et de vos recherches immobilières</strong>
                      </td>
                      <td rowSpan="4">
                        seloger.com
                        <br />
                        selogerneuf.com
                        <br />
                        bellesdemeures.com
                        <br />
                        bureaux-commerces seloger.com
                      </td>
                      <td>
                        Lorsque vous naviguez sur le Site Internet ou l’Application, nous collectons les données suivantes afin de gérer votre navigation, d’
                        <strong>optimiser votre temps de recherche et vos recherches géographiques via la cartographie et proposer des biens proches de vos lieux favoris </strong>
                        (“Voir les biens autour de ma zone”), d’optimiser votre temps de recherche et proposer des recherches récentes, de déterminer une zone de vie idéale et de
                        calculer un périmètre en fonction de votre indication de temps de trajet maximum souhaité et des modes de transports:
                        <ul>
                          <li>données de géolocalisation,</li>
                          <li>critères de recherches renseignés,</li>
                          <li>annonces consultées et date de consultation.</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Lorsque vous naviguez sur le Site Internet ou l’Application, nous collectons des données sur votre navigation (nombre de visites, pages visitées, historique
                        de navigation, actions effectuées sur le site, origine de l’accès au site, adresse IP) et générons un identifiant de<strong> mesure d’audience</strong>,
                        dans le respect de la base légale requise par la réglementation, afin de générer des statistiques sur sa fréquentation et son utilisation.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Lorsque vous naviguez sur le Site Internet ou l'Application, sous réserve de votre consentement préalable pour le dépôt de traceurs de la finalité associée,
                        nous collectons vos données de navigation, afin de vous <strong>diffuser des annonces publicitaires</strong> adaptées à vos centres d'intérêts. A défaut de
                        consentement, nous collectons votre adresse IP afin de vous diffuser de la publicité contextuelle.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Lorsque vous naviguez sur le Site Internet ou l’Application, nous collectons des données sur votre navigation afin d’assurer la
                        <strong> sécurité de nos services</strong> en détectant/retraçant toute tentative de malveillance, intrusion informatique ou violation des CGU.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        seloger.com selogerneuf.com <br /> bellesdemeures.com
                      </td>
                      <td>
                        Lors de la <strong>mise en favoris </strong>(“Sauvegarder”) d’un bien immobilier, nous collectons les données suivantes afin de pouvoir vous alerter en cas
                        de changement de prix d’une annonce, de vous permettre de retrouver ces annonces dans vos favoris depuis le Site Internet ou l’Application et identifier les
                        annonces précédemment mises en favori:
                        <ul>
                          <li>caractéristiques de l’annonce sauvegardée,</li>
                          <li>identifiant unique auquel associer le favori.</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>seloger.com</td>
                      <td>
                        Lorsque vous naviguez sur le Site Internet ou l’Application, sous réserve de votre consentement préalable pour ledépôt de traceurs de la finalité associée,
                        nous collectons des données sur votre navigation (nombre de demandes de contacts associées à votre adresse mail et pages visitées) et générons un
                        identifiant unique afin d’activer la<strong> Recommandation d’Annonces</strong> et de vous recommander par notification des biens qui pourraient vous
                        intéresser.
                      </td>
                    </tr>
                    <tr>
                      <td rowSpan="2">
                        <strong>Publication de votre annonce</strong>
                      </td>
                      <td rowSpan="2">seloger.com&nbsp;</td>
                      <td>
                        Lorsque vous <strong>déposez une annonce de location</strong> d'un bien immobilier en tant que propriétaire particulier, vous nous communiquez les
                        informations suivantes afin de publier le bien sur le Site Internet et l'Application et d'être contacté par les personnes intéressées:
                        <ul>
                          <li>caractéristiques du bien (localisation, description, montant du bien, et facultativement, photos et vidéos),</li>
                          <li>numéro de téléphone (à des fins d'authentification à double facteur),</li>
                          <li>données de création de compte (adresse email et mot de passe créé).</li>
                          <li>
                            Afin de détecter toute tentative de fraude, nous et notre partenaire anti-fraude (Navee, en tant que responsable de traitement indépendant) traitons les
                            données que vous nous communiquez, d'éventuels justificatifs ultérieurs d'identité ou de domicile ainsi que l'adresse IP du terminal utilisé. Ce
                            traitement prévoit une modération manuelle des annonces potentiellement frauduleuses et ne constitue donc pas une prise de décision automatisée au sens
                            de l'article 22 du RGPD.
                          </li>
                        </ul>
                        Par la suite, vous êtes susceptible de nous communiquer une vidéo de votre visage afin de vérifier la correspondance de votre visage avec la photo de votre
                        pièce d'identité via reconnaissance faciale. Dans ce cadre, nous vous demandons d’accepter expressément l'utilisation de la reconnaissance faciale sur votre
                        visage afin de certifier votre pièce d'identité.&nbsp;Par ailleurs, dans ce cadre, nous pouvons également vous recontacter par mail ou par téléphone dans le
                        cadre d<strong>'enquêtes de satisfaction, études et sondages.</strong>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Lorsque vous déposez une <strong>annonce en tant que professionnel</strong> pour un bien immobilier via les formulaires dédiés, vous nous communiquez les
                        informations suivantes afin de publier le bien sur le Site Internet et l'Application et d'être contacté par les personnes intéressées:
                        <ul>
                          <li>caractéristiques du bien (localisation, description, montant du bien, et facultativement, photos et vidéos),</li>
                          <li>état civil,</li>
                          <li>numéro de téléphone,</li>
                          <li>données de création de compte professionnel (adresse email et mot de passe créé),</li>
                          <li>SIRET, raison sociale, adresse de facturation, à des fins de facturation de la publication.</li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td rowSpan="2">
                        <strong>Gestion de l’affichage des biens vendus</strong>
                      </td>
                      <td rowSpan="2">seloger.com&nbsp;</td>
                      <td>
                        Lorsque vous avez donné mandat à un professionnel de l’immobilier ayant souscrit une offre de publication d’annonces auprès de DCF, ce dernier peut nous
                        transmettre les informations suivantes pour afficher les biens vendus sur le Site ou l’Application:
                        <ul>
                          <li>caractéristiques du bien (type de bien, nombre de pièces, surface loi Carrez),</li>
                          <li>localisation du bien,</li>
                          <li>prix et date de la vente,</li>
                          <li>professionnel de l’immobilier mandataire.</li>
                        </ul>
                        Ces informations nous permettent de renseigner nos Utilisateurs sur l'état du marché immobilier de leur secteur et d’utiliser les caractéristiques des biens
                        vendus dans notre calcul d'estimation en ligne du prix d’un bien immobilier.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Par ailleurs, lorsqu'une mutation d’un bien immobilier est opérée en France, l’administration fiscale met gratuitement à disposition du public les données
                        relatives à ces mutations pour les cinq dernières années au titre du décret n° 2018-1350 du 28 décembre 2018, pris en application de la loi n° 2018-727 du
                        10 août 2018. Ces données sont issues des traitements informatisés relatifs à la publicité foncière et à la documentation littérale du cadastre (« Demande
                        de Valeurs Foncières (DVF) »). Nous collectons et réutilisons, conformément aux Conditions Générales d’Utilisation de la DVF, les informations suivantes
                        relatives à des ventes uniquement et issues de cette base de données afin de renseigner nos Utilisateurs sur l’état du marché immobilier de leur secteur:
                        <ul>
                          <li>caractéristiques du bien (type de bien, nombre de pièces, surface loi Carrez),</li>
                          <li>localisation du bien,</li>
                          <li>prix et date de la vente.</li>
                          <li>
                            Concernant les données de la DVF, la fourniture d’une information préalable sur le traitement aux personnes concernées par ces ventes étant impossible
                            ou exigeant des efforts disproportionnés, DCF n’est pas tenu d’informer individuellement ces personnes et les présentes mentions permettent
                            l’information des personnes.
                          </li>
                        </ul>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <h2>3. Pour quelles finalités traitons-nous vos données et sur quels fondements ?</h2>
              <h2>Nous traitons vos données pour les finalités suivantes et selon les bases légales précisées ci-dessous :</h2>
              <table>
                <tbody>
                  <tr>
                    <td>
                      <strong>Base Légale</strong>
                    </td>
                    <td>
                      <strong>Site ou Application</strong>
                    </td>
                    <td>
                      <strong>Finalités du traitement</strong>
                    </td>
                  </tr>
                  <tr>
                    <td rowSpan="5">
                      <strong>Exécution du contrat (Conditions Générales d’Utilisation du Site ou de l’Application)</strong>
                    </td>
                    <td className="sites">
                      SeLoger <br />
                      Belles Demeures <br />
                      SeLoger Neuf <br />
                      SeLoger Bureaux et Commerce <br />
                      SeLoger Construire
                    </td>
                    <td>
                      Transmettre vos demandes de contacts ou d’informations à des professionnels de l’immobilier ou promoteurs,
                      <br />
                      Pouvoir vous alerter en cas de changement de prix d'une annonce mise en favori, vous permettre de retrouver ces annonces dans vos favoris depuis le Site
                      Internet et identifier les annonces précédemment mises en favori.
                    </td>
                  </tr>
                  <tr>
                    <td>SeLoger</td>
                    <td>
                      Publier le bien que vous souhaitez diffuser sur notre Site Internet et Application et être contacté par les personnes intéressées,
                      <br />
                      Créer votre compte et vous permettre de vous identifier,
                      <br />
                      Création d’une annonce en “favori”.
                      <br />
                      Vous envoyer des emails de services associés à l'exécution de votre contrat (ex: compte créé, modification de mot de passe),
                      <br />
                      Répondre à une annonce de location et transmettre les éléments à déclarer par un candidat à une location permettant au propriétaire loueur d'apprécier sa
                      situation financière,
                      <br />
                      Sécuriser votre compte via un système d'authentification à double facteur,
                      <br />
                      Facturer les Utilisateurs professionnels pour la publication d'annonces unitaires,
                      <br />
                      Transmettre vos demandes de contact à des particuliers louant un bien,
                      <br />
                      Transmettre l'horaire de visite souhaité d'un bien immobilier à un professionnel de l'immobilier, Client de DCF,
                      <br />
                      Répondre à votre demande d'estimation automatisée du prix de votre bien immobilier et vous transmettre le résultat par email.
                      <br />
                    </td>
                  </tr>
                  <tr>
                    <td>SeLoger Neuf</td>
                    <td>
                      Appeler en VoIP le promoteur immobilier,Transmettre votre demande de contact à nos partenaires spécialisés pour gérer votre demande de projet
                      d'investissement,
                    </td>
                  </tr>
                  <tr>
                    <td>Belles Demeures</td>
                    <td>Répondre à votre demande d’accompagnement et vous recontacter par téléphone pour affiner l’estimation immobilière de votre bien.</td>
                  </tr>
                  <tr>
                    <td>SeLoger Bureaux et Commerce</td>
                    <td>Créer votre compte professionnel et vous permettre de vous identifier</td>
                  </tr>
                  <tr>
                    <td rowSpan="4">
                      <strong>Consentement</strong>
                    </td>
                    <td>
                      SeLoger <br />
                      Belles Demeures <br />
                      SeLoger Neuf <br />
                      SeLoger Bureaux et Commerce <br />
                      SeLoger Construire
                    </td>
                    <td>
                      Estimer automatiquement le degré d'intérêt de votre recherche et communiquer cette indication au professionnel de l'immobilier que vous contactez pour l'aider
                      à améliorer sa gestion des demandes de contact, lui permettre de mieux comprendre votre projet immobilier d'achat et lui indiquer les annonces qui pourraient
                      vous intéresser (données récoltées via le dépôt de cookies dédiés soumis à consentement,
                      <br />
                      Permettre au professionnel de l’immobilier de mieux comprendre votre projet immobilier d’achat,
                      <br />
                      Indiquer au professionnel de l’immobilier les annonces qui pourraient vous intéresser,
                      <br />
                      Vous inscrire à la newsletter suite à votre demande,
                      <br />
                      Vous recommander et vous proposer par notification et alertes emails des biens immobiliers qui pourraient vous intéresser,
                      <br />
                      Vous diffuser des annonces et contenus publicitaires adaptés à vos centres d'intérêts via le dépôt de cookies,
                    </td>
                  </tr>
                  <tr>
                    <td>SeLoger</td>
                    <td>
                      Certifier le profil d'un loueur via un contrôle documentaire et la mise en oeuvre de la reconnaissance faciale (lutte contre la fraude),
                      <br />
                      Transmettre vos demandes de contact à une sélection de professionnels de l'immobilier dans le cadre d'un projet d'achat d'un bien immobilier,
                      <br />
                      Transmettre vos demandes de contact à une sélection de professionnels de l'immobilier dans le cadre d'un projet de vente d'un bien immobilier,
                      <br />
                      Transmettre votre demande d'obtention d'une simulation Pinel à notre partenaire spécialisé en investissement,
                      <br />
                      Obtenir, suite à votre demande, un devis automatisé d'assurance de prêt par notre partenaire dédié,
                      <br />
                      Permettre à notre partenaire dédié de vous recontacter par mail pour affiner votre tarif d'assurance de prêt,
                      <br />
                      Obtenir, suite à votre demande, un devis automatisé de déménagement par notre partenaire dédié,
                    </td>
                  </tr>
                  <tr>
                    <td>SeLogerNeuf</td>
                    <td>
                      vous envoyer des alertes emails pour des biens similaires correspondant à vos critères de recherche, par email ou notification, suite à votre activation de
                      l’alerte “Enregistrer la recherche”,
                      <br />
                      recevoir les offres des promoteurs de SeLoger neuf par SMS / Email selon vos préférences.
                    </td>
                  </tr>
                  <tr>
                    <td>SeLoger Bureaux et Commerce</td>
                    <td>
                      Confier votre demande à d’autres agences, professionnels de l’immobilier, clients de DCF, qui sont susceptibles de vous recontacter pour vous proposer des
                      biens similaires à votre recherche.
                      <br />
                      Confier votre recherche dans le cadre du formulaire de Contact Preneur afin que nous transmettions votre demande de contact à une sélection de professionnels
                      de l’immobilier dans le cadre de votre projet de recherche d’un bien.
                      <br />
                      Vous faire accompagner dans le cadre du formulaire Opportunité Mandat afin que nous transmettions votre demande de contact à une sélection de professionnels
                      de l’immobilier dans le cadre de votre projet de vente d'un bien immobilier.
                    </td>
                  </tr>
                  <tr>
                    <td rowSpan="2">
                      <strong>Intérêt Légitime</strong>
                    </td>
                    <td>
                      SeLoger <br />
                      SeLoger Neuf <br />
                      Belles Demeures <br />
                      SeLoger Bureaux et Commerce <br />
                      SeLoger Construire
                    </td>
                    <td>
                      Répondre à vos questions adressées au service client (amélioration de l'expérience utilisateur),
                      <br />
                      Vous proposer des Services Analogues à votre demande initiale sauf opposition de votre part c'est à dire vous envoyer des alertes pour des biens similaires à
                      vos critères de recherche, par email ou notification, suite au remplissage du formulaire de prise de contact avec un professionnel de l'immobilier
                      (prospection pour des biens similaires par le Site ou l’Application avec droit d’opposition),
                      <br />
                      Vous proposer des services d'accompagnement autour de votre projet immobilier sauf opposition de votre part (prospection pour des services analogues avec
                      droit d’opposition),Mesurer l'audience du site : générer des statistiques sur la fréquentation et l'utilisation de nos services (bonne administration du site
                      et connaissance utilisateur),
                      <br />
                      Personnaliser votre expérience sur le Site et l'Application (amélioration de l'expérience utilisateur),
                      <br />
                      Optimiser votre temps de recherche et proposer des recherches récentes et annonces consultées (amélioration de l'expérience utilisateur),
                      <br />
                      Vous recontacter par mail ou par téléphone dans le cadre d'enquêtes de satisfaction, études et sondages sur la qualité du service fourni et collecter à cette
                      occasion vos retours (connaissance utilisateur),
                      <br />
                      Répertorier les annonces que vous avez vues précédemment (amélioration de l'expérience utilisateur),
                      <br />
                      Améliorer la performance du service (amélioration du service),
                      <br />
                      Vous diffuser de la publicité contextuelle (amélioration de la pertinence des publicités),
                      <br />
                      Améliorer le service et la formation des conseillers de nos centres d'appels (amélioration du service et de la formation),
                      <br />
                      Assurer la sécurité de nos services en détectant/retraçant toute tentative de malveillance, intrusion informatique ou violation des CGU (sécurité
                      informatique),
                      <br />
                      Vérifier et détecter toute tentative de signalement abusif (protection contre les actions malveillantes),
                      <br />
                      Vérifier et détecter toute tentative de fraude (lutte anti-fraude),
                      <br />
                      Prendre en compte votre signalement d'une annonce frauduleuse et vous informer des suites données (prévention de la fraude),
                      <br />
                      Conserver les données à des fins de preuves (sécurité juridique).
                      <br /> Réaliser des économies d'échelle, identifier de nouvelles opportunités, améliorer les produits et services existants et d'optimiser les processus
                      commerciaux (synergies au sein du Groupe Aviv)
                    </td>
                  </tr>
                  <tr>
                    <td>SeLoger</td>
                    <td>
                      Vous recontacter par email, SMS ou téléphone, sauf opposition de votre part, afin de de recevoir des propositions d'accompagnement autour de votre projet
                      immobilier lorsque vous avez effectué une demande d'estimation (prospection pour services analogues),
                      <br />
                      Gestion de l’affichage des Biens Vendus (transparence du marché de l’immobiliers)
                      <br />
                      Utiliser les caractéristiques des Biens Vendus dans notre calcul d'estimation en ligne (amélioration de la précision des estimations).
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>Obligations Légales</strong>
                    </td>
                    <td>
                      SeLoger <br />
                      SeLoger Neuf <br />
                      Belles Demeures <br />
                      SeLoger Bureaux et Commerce <br />
                      SeLoger Construire
                    </td>
                    <td>Se conformer à nos obligations légales en matière fiscale et comptable.</td>
                  </tr>
                </tbody>
              </table>
              <h2>4. Qui sont les destinataires de vos données ?</h2>
              <h2>
                Lorsque vos données sont traitées par le personnel de DCF, nous nous attachons à ce que seules les personnes dont les missions sont nécessaires à l’accomplissement
                de nos finalités puissent y accéder.&nbsp;
              </h2>
              <p style={{ textAlign: 'justify' }}>
                De plus, le Groupe DCF propose divers services accessibles sur différents sites (et applications associées) pour lesquels il est le responsable de traitement. Vous
                pouvez trouver une liste complète des sites du groupe disponible via ce lien:&nbsp;
                <a href="https://www.groupeseloger.com/" target="_blank" rel="noopener noreferrer">
                  www.groupeseloger.com
                </a>
                .
              </p>
              <p style={{ textAlign: 'justify' }}>
                Vos données sont destinées à DCF notamment afin de vous faire bénéficier de services personnalisés et de faciliter votre navigation.
              </p>
              <p style={{ textAlign: 'justify' }}>
                Dans le cadre du formulaire d’estimation automatisée du prix d’un bien immobilier, nous partageons vos données avec notre société filiale Falguière Conseil SAS,
                responsable conjoint pour ce traitement, afin d'obtenir l'estimation du prix de votre bien sur la base de nos données communes et afin de vous proposer des services
                d'accompagnement autour de votre projet immobilier.
              </p>
              <p style={{ textAlign: 'justify' }}>
                Dans le cadre de la lutte anti-fraude sur les annonces de locations déposées par des particuliers, nous partageons les données relatives à des annonces frauduleuses
                avec notre partenaire de lutte anti-fraude, Navee, en tant que responsable de traitement, afin de détecter des fraudes ultérieures.
              </p>
              <p style={{ textAlign: 'justify' }}>
                Enfin, vos données peuvent être communiqués, lorsque cela est nécessaire dans le cadre des finalités précisées au point 3, aux destinataires suivants:
              </p>
              <ul>
                <li>
                  à Aviv Group GmbH, société-mère de Digital Classifieds France et à toutes les sociétés qui lui appartiennent à des fins d’analyses et de croissance - en vue de
                  réaliser des économies d'échelle, identifier de nouvelles opportunités, améliorer les produits et services existants et optimiser les processus commerciaux,
                </li>
              </ul>
              <ul>
                <li>aux éditeurs partenaires de supports non édités par Digital Classifieds France aux fins d’exécution de nos Conditions Générales de Vente,</li>
              </ul>
              <ul>
                <li>
                  aux partenaires immobiliers, clients de DCF, agissant en tant que responsable de traitement, que vous souhaitez expressément et spécifiquement contacter afin de
                  répondre à vos demandes (information sur un bien, une agence, demande d'estimation…),
                </li>
              </ul>
              <ul>
                <li>aux prestataires de DCF agissant en tant que sous-traitant:</li>
                <ul>
                  <li>prestataires spécialiste de la vérification et la sécurisation de documents,</li>
                  <li>
                    prestataires chargés notamment de fournir un service et des publicités adaptés aux Utilisateurs et de mesurer la fréquentation du Site Internet et/ou de
                    l'Application,
                  </li>
                  <li>prestataires de prospection commerciale,</li>
                  <li>prestataires d’organisations de jeux concours,</li>
                  <li>prestataires d’hébergement, de maintenance et d’applications cloud,</li>
                  <li>prestataires de centre d’appels,</li>
                  <li>prestataires chargés de réaliser des études de satisfaction.</li>
                </ul>
              </ul>
              <ul>
                <li>
                  aux partenaires commerciaux de DCF, agissant en tant que responsable de traitement, lorsque les utilisateurs ont accepté expressément de recevoir les offres
                  promotionnelles de leur part.
                </li>
              </ul>
              <ul>
                <li>
                  aux prestataires publicitaires visés au sein de notre plateforme de gestion de cookies référencés dans la liste “Voir nos partenaires“. Vous pouvez contrôler le
                  dépôt de cookies par ces derniers via notre plateforme de gestion de cookies.
                </li>
              </ul>
              <ul>
                <li>aux autorités administratives ou judiciaires autorisées afin de répondre à nos obligations légales ou une demande légale de ces autorités.</li>
              </ul>
              <p style={{ textAlign: 'justify' }}>
                <strong>5. Transferts de données hors UE</strong>
              </p>
              <p style={{ textAlign: 'justify' }}>
                Les données traitées par certains de nos sous-traitants peuvent être transférées hors de l’Union Européenne. Lorsque des données sont transférées hors UE, nous
                veillons à ce que les pays de destination assurent un niveau adéquat de protection des données, suivant une décision d’adéquation de la Commission Européenne ou à
                mettre en place des garanties appropriées de nature contractuelle, technique et organisationnelle, conformément au RGPD, afin de s’assurer du niveau de protection
                de vos données, équivalent à celui dont elles bénéficieraient au sein de l’UE.
              </p>
              <p style={{ textAlign: 'justify' }}>
                <strong>6. Quelle est la durée de conservation de vos données ?</strong>
              </p>
              <p style={{ textAlign: 'justify' }}>
                Nous conservons vos données pour des durées variables en fonction du type de données et des finalités pour lesquelles elles sont traitées dans les conditions
                suivantes:
              </p>
              <div>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <p>
                          <strong>Type de données</strong>
                        </p>
                      </td>
                      <td>
                        <p>
                          <strong>Site ou Application</strong>
                        </p>
                      </td>
                      <td>
                        <p>
                          <strong>Durée de conservation</strong>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>Données collectées par un formulaire (sauf estimation) ou activation de l’alerte, de mise en favoris ou issues d’un compte</p>
                        <p>Données de navigation relative à votre projet immobilier / à la personnalisation du contenu / à la mesure d’audience / à la prévention de la fraude</p>
                      </td>
                      <td>
                        SeLoger <br />
                        SeLoger Neuf <br /> Belles Demeures <br />
                        SeLoger Bureaux et Commerce <br />
                        SeLoger Construire
                      </td>
                      <td>
                        <p style={{ textAlign: 'justify' }}>
                          <strong>3 ans</strong> dans une base active à compter de votre dernière activité ou contact (modification de son compte, navigation, saisie d'un
                          formulaire sur l'un des sites Internet et/ou sur l'une des applications, ...) sur l'un des sites Internet (et applications associées) “Habitation” du
                          Groupe SeLoger suivants:
                        </p>
                        <ul>
                          <li>seloger.com</li>
                          <li>selogerneuf.com</li>
                          <li>seloger-construire.com</li>
                          <li>bellesdemeures.com</li>
                          <li>lacoteimmo.com</li>
                          <li>logic-immo.com</li>
                          <li>neuf.logic-immo.com</li>
                          <li>construire.logic-immo.com</li>
                          <li>lux-residence.com</li>
                        </ul>
                        <p>
                          <strong>2 ans additionnels</strong> dans une base d’archive pseudonymisée à accès restreint à des fins de preuves.
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>Enregistrement des Conversations téléphoniques</p>
                      </td>
                      <td>SeLoger SeLoger Neuf Belles Demeures SeLoger Bureaux et Commerce SeLoger Construire</td>
                      <td>
                        <p>
                          <strong>6 mois </strong>maximum
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>Documents et pièces comptables</p>
                      </td>
                      <td>
                        SeLoger <br />
                        SeLoger Neuf <br />
                        Belles Demeures <br /> SeLoger Bureaux et Commerce <br /> SeLoger Construire
                      </td>
                      <td>
                        <p>
                          <strong>10 ans</strong>, à titre de preuve comptable
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>Géolocalisation</p>
                      </td>
                      <td>
                        SeLoger <br /> SeLoger Neuf <br /> SeLoger Construire
                      </td>
                      <td>
                        <p>
                          Utilisation en temps réel et <strong>suppression immédiate</strong>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>Données relatives à une annonce publiée</p>
                      </td>
                      <td>
                        <p>SeLoger</p>
                      </td>
                      <td>
                        <p>
                          <strong>3 ans</strong> dans une base active à compter de l’expiration du contrat
                        </p>
                        <p>
                          <strong>2 ans additionnels</strong> dans une base d’archive pseudonymisée à accès restreint à des fins de preuves.
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>Données relatives à la lutte anti-fraude sur les annonces publiées par des propriétaires particuliers</p>
                      </td>
                      <td>
                        <p>SeLoger</p>
                      </td>
                      <td>
                        <p>
                          <strong>30 jours </strong>dans une base active à compter de la publication de l'annonce
                        </p>
                        <p>
                          <strong>5 ans additionnels</strong> dans une base d'archive pseudonymisée à accès restreint à des fins de preuves.
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p>Données relatives à la certification de profil propriétaire</p>
                      </td>
                      <td>
                        <p>SeLoger</p>
                      </td>
                      <td>
                        <p>
                          <strong>Suppression immédiate</strong> des modèles biométriques&nbsp;
                        </p>
                        <p>
                          <strong>3 mois</strong> dans une base active à compter de la fourniture des données
                        </p>
                        <p>
                          <strong>5 ans</strong> dans une base d'archive à accès restreint à des fins de preuves.
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>Biens Vendus (adresse postale et caractéristiques du bien vendu)</td>
                      <td>SeLoger</td>
                      <td>
                        <strong>20 ans</strong> à compter de la collecte à des fins statistiques et de renseignement sur le marché de l'immobilier
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <h2 style={{ textAlign: 'justify' }}>7. Quels sont vos droits et comment les exercer ?</h2>
              <h2 style={{ textAlign: 'justify' }}>Conformément au RGPD et dans les conditions prévues par ce texte, vous disposez des droits suivants:</h2>
              <ul>
                <li>
                  <strong>Droit d’accès</strong>: vous pouvez obtenir la confirmation que vos données sont traitées, et si tel est le cas, d’accéder à vos données et des
                  informations sur les circonstances du traitement.
                </li>
                <li>
                  <strong>Droit de rectification</strong>: vous pouvez obtenir de DCF la rectification de vos données lorsqu’elles sont inexactes ou incomplètes, dans les meilleurs
                  délais.
                </li>
                <li>
                  <strong>Droit à l’effacement</strong>: vous pouvez dans certaines conditions obtenir de DCF l'effacement de vos données, dans les meilleurs délais.
                </li>
                <li>
                  <strong>Droit à la limitation</strong>: vous pouvez obtenir la limitation du traitement lorsque vous contestez l’exactitude des données, la licéité de leur
                  traitement, ou vous vous opposez au traitement ou vous souhaitez leur conservation à des fins de preuves.
                </li>
                <li>
                  <strong>Droit à la portabilité</strong>: vous pouvez recevoir vos données que nous traitons de manière automatisée et que vous avez fournies sur la base d’un
                  contrat ou de votre consentement dans un format structuré, couramment utilisé et lisible par machine ou obtenir la transmission de ces données à un autre
                  responsable de traitement.
                </li>
                <li>
                  <strong>Droit d’opposition</strong>: vous pouvez vous opposer à tout moment à un traitement de vos données par DCF, sauf si DCF dispose de motifs légitimes et
                  impérieux au traitement de vos données. En cas de prospection commerciale, vous pouvez vous y opposer sans motif.
                </li>
                <li>
                  <strong>Droit de ne pas faire l'objet d'une décision fondée sur un traitement automatisé</strong>: vous avez le droit de ne pas faire l’objet d’une décision
                  fondée exclusivement sur un traitement automatisé et produisant des effets juridiques vous concernant ou vous affectant similairement de manière significative,
                  sauf lorsque ce traitement est nécessaire à la conclusion ou l’exécution d’un contrat ou est autorisée par la loi.
                </li>
                <li>
                  <strong>Droit d’introduire une réclamation</strong>: vous avez le droit d’introduire une réclamation auprès d’une autorité de contrôle, notamment la CNIL.
                </li>
                <li>
                  <strong>Directives en cas de décès</strong>: vous avez le droit de formuler des directives concernant le sort de vos données en cas de décès.
                </li>
              </ul>
              <p style={{ textAlign: 'justify' }}>
                Pour exercer vos droits, il vous suffit de nous contacter via la rubrique « Nous contacter » (mentionner ses noms, prénoms, adresse de courrier électronique),
                disponible via ce lien&nbsp;
                <a href="https://www.seloger.com/contact.html?query=legal#formulaire" target="_blank" rel="noopener noreferrer">
                  lien
                </a>
                <span style={{ textDecoration: 'underline' }}>.</span>
              </p>
              <p style={{ textAlign: 'justify' }}>
                Vous pouvez également adresser un simple courrier à DCF à l’adresse postale suivante : DIGITAL CLASSIFIEDS FRANCE – A l’attention du Délégué à la Protection des
                Données – 65, rue Ordener 75018 Paris.
              </p>
              <p style={{ textAlign: 'justify' }}>
                Si vous bénéficiez d’un compte Utilisateur sur le Site ou l’Application, vous pouvez également gérer vos abonnements, alertes et newsletters au sein de l’espace
                Alerte et Newsletters.
              </p>
              <p style={{ textAlign: 'justify' }}>
                <strong>8. Sécurité de vos données</strong>
              </p>
              <p style={{ textAlign: 'justify' }}>
                DCF collecte et traite les Données avec la plus grande confidentialité et sécurité, et dans le respect des lois applicables à DCF.
              </p>
              <p style={{ textAlign: 'justify' }}>
                DCF s'engage à prendre toutes mesures raisonnables nécessaires à la sécurisation et à la protection des Données des Utilisateurs du Site Internet et/ou de
                l'Application et des Services, collectées et traités par ses soins (notamment pare-feu, contrôles d'accès physiques aux data center, habilitations, etc.).
              </p>
              <p style={{ textAlign: 'justify' }}>
                <strong>9. Comment contacter le Délégué à la Protection des Données (DPO) ?</strong>
              </p>
              <p style={{ textAlign: 'justify' }}>
                DCF a désigné un Délégué à la Protection des Données. Pour toute question relative à la collecte et au traitement de vos données par DCF, vous pouvez contacter le
                DPO en cliquant{' '}
                <a style={{ textDecoration: 'underline' }} target="_blank" rel="noopener noreferrer" href="mailto:contact.dpo@groupeseloger.com">
                  ici
                </a>{' '}
                (ou clic droit sur "ici" puis copier l'adresse email et coller tant que destinataire dans votre messagerie).
              </p>
              <p style={{ textAlign: 'justify' }}>
                <strong>10. Notice d'information spécifique à l'enregistrement des appels téléphoniques entrants et sortants par la société DCF</strong>
              </p>
              <p style={{ textAlign: 'justify' }}>
                La société DCF utilise un dispositif d'enregistrement sélectif des appels entrants et sortants initiés par les téléconseillers aux fins précisées au sein de la
                présente Notice d'Information.
              </p>
              <p style={{ textAlign: 'justify' }}>
                <strong>a) Qui est responsable du traitement ?</strong>
              </p>
              <p style={{ textAlign: 'justify' }}>
                DCF (Groupe SeLoger), éditeur de portails immobiliers, inscrite au Registre du Commerce et des Sociétés de Paris sous le numéro 789 177 391, dont le siège social
                est situé 65, rue Ordener 75018 PARIS est responsable du traitement de vos données à caractère personnel.
              </p>
              <p style={{ textAlign: 'justify' }}>
                <strong>b) Pour quelles finalités traitons-nous vos données et sur quels fondements ?</strong>
              </p>
              <p style={{ textAlign: 'justify' }}>
                L'enregistrement sélectif des appels téléphoniques entrants et sortants permet à la société DCF de poursuivre les finalités suivantes :
              </p>
              <ul>
                <li>la formation des employés ;</li>
                <li>l'évaluation des employés ;</li>
                <li>l'amélioration de la qualité du service.</li>
              </ul>
              <p>Ce traitement est mis en œuvre sur le fondement des intérêts légitimes de la société DCF :</p>
              <ul>
                <li>d'améliorer ses techniques commerciales,</li>
                <li>de vérifier le respect des engagements contractuels des prestataires.</li>
              </ul>
              <p style={{ textAlign: 'justify' }}>
                <strong>c) Quels sont les destinataires de vos données ?</strong>
              </p>
              <p>Dans la limite de leurs attributions respectives, sont destinataires des appels enregistrés :</p>
              <ul>
                <li>les collaborateurs autorisés du prestataire de services (centre d'appels), sous-traitant, sous contrat avec DCF,</li>
                <li>les collaborateurs autorisés de la société DCF.</li>
              </ul>
              <p style={{ textAlign: 'justify' }}>
                <strong>d) Quelle est la durée de conservation de vos données ?</strong>
              </p>
              <p style={{ textAlign: 'justify' }}>Les appels enregistrés sont conservés pour une durée maximale de 6 mois.</p>
              <p style={{ textAlign: 'justify' }}>
                <strong>e) Quels sont vos droits et comment les exercer ?</strong>
              </p>
              <p style={{ textAlign: 'justify' }}>Conformément au RGPD et dans les conditions prévues par ce texte, vous disposez des droits suivants :</p>
              <ul>
                <li>
                  Droit d'accès: vous pouvez obtenir la confirmation que vos données sont traitées, et si tel est le cas, d'accéder à vos données et des informations sur les
                  circonstances du traitement;
                </li>
                <li>Droit de rectification: vous pouvez obtenir de DCF la rectification de vos données lorsqu'elles sont inexactes ou incomplètes, dans les meilleurs délais;</li>
                <li>Droit à l'effacement : vous pouvez dans certaines conditions obtenir de DCF l'effacement de vos données, dans les meilleurs délais;</li>
                <li>
                  Droit à la limitation : vous pouvez obtenir la limitation du traitement lorsque vous contestez l'exactitude des données, la licéité de leur traitement, ou vous
                  vous opposez au traitement ou vous souhaitez leur conservation à des fins de preuves;
                </li>
                <li>
                  Droit à la portabilité : vous pouvez recevoir vos données que nous traitons de manière automatisée et que vous avez fournies sur la base d'un contrat ou de votre
                  consentement dans un format structuré, couramment utilisé et lisible par machine ou obtenir la transmission de ces données à un autre responsable de traitement;
                </li>
                <li>
                  Droit d'opposition : vous pouvez vous opposer à tout moment à un traitement de vos données par DCF, sauf si DCF dispose de motifs légitimes et impérieux au
                  traitement de vos données. En cas de prospection commerciale, vous pouvez vous opposer sans motif;
                </li>
                <li>
                  Droit de ne pas faire l'objet d'une décision fondée sur un traitement automatisé : vous avez le droit de ne pas faire l'objet d'une décision fondée exclusivement
                  sur un traitement automatisé et produisant des effets juridiques vous concernant ou vous affectant similairement de manière significative, sauf lorsque ce
                  traitement est nécessaire à la conclusion ou l'exécution d'un contrat ou est autorisée par la loi;
                </li>
                <li>Droit d'introduire une réclamation : vous avez le droit d'introduire une réclamation auprès d'une autorité de contrôle, notamment la CNIL.</li>
                <li>Directives en cas de décès : vous avez le droit de formuler des directives concernant le sort de vos données en cas de décès.</li>
              </ul>
              <p>
                Pour exercer vos droits, il vous suffit de nous contacter en précisant explicitement que votre demande concerne les enregistrements téléphoniques, via la rubrique «
                Nous contacter » (mentionner ses noms, prénoms, adresse de courrier électronique), disponible via ce lien&nbsp;
                <a href="https://www.seloger.com/contact.html?query=legal#formulaire" target="_blank" rel="noopener noreferrer">
                  lien
                </a>
                .
              </p>
              <p style={{ textAlign: 'justify' }}>
                Vous pouvez également adresser un simple courrier à DCF à l'adresse postale suivante: DIGITAL CLASSIFIEDS FRANCE – A l'attention du Délégué à la Protection des
                Données – 65, rue Ordener 75018 Paris.
              </p>
              <p style={{ textAlign: 'center' }}>
                <strong>POLITIQUE DE COOKIES</strong>
              </p>
              <p style={{ textAlign: 'center' }}>
                <strong>SITE WEB ET APPLICATIONS GROUPE SELOGER&nbsp;</strong>
              </p>
              <p style={{ textAlign: 'justify' }}>
                Lors de la consultation du Site Internet et/ou de l'Application, des informations sont susceptibles d'être enregistrées dans des fichiers « cookies » installés dans
                l'ordinateur, tablette ou téléphone mobile de l'Utilisateur. Cette page permet de comprendre ce qu'est un cookie, à quoi il sert et comment on peut le paramétrer.
              </p>
              <p style={{ textAlign: 'justify' }}>
                <strong>1. Qu’est-ce qu’un cookie ?</strong>
              </p>
              <p style={{ textAlign: 'justify' }}>
                Un cookie est un fichier texte susceptible d'être enregistré, sous réserve du choix de l'Utilisateur, dans un espace dédié du disque dur de votre terminal, à
                l'occasion de la consultation d'un service en ligne grâce au logiciel de navigation de l'Utilisateur.
              </p>
              <p style={{ textAlign: 'justify' }}>
                Un fichier cookie permet à son émetteur d'identifier le terminal dans lequel il est enregistré, pendant la durée de validité du cookie.
              </p>
              <h2 style={{ textAlign: 'justify' }}>2. A quoi servent les cookies émis sur le Site Internet et/ou l’Application ?</h2>
              <p style={{ textAlign: 'justify' }}>Les cookies et traceurs déposés sur notre Site Internet et/ou notre Application sont de différentes natures :</p>
              <p style={{ textAlign: 'justify' }}>
                <strong>a) Les cookies fonctionnels</strong>
              </p>
              <p style={{ textAlign: 'justify' }}>Ces cookies que nous déposons permettent :</p>
              <ul>
                <li>de vous identifier lorsque vous vous connectez sur notre Site ou Application,</li>
                <li>
                  d'adapter la présentation du Site et de l’Application aux préférences d'affichage de votre terminal (langue utilisée, résolution d'affichage, système
                  d'exploitation utilisé, etc),
                </li>
                <li>
                  de mémoriser des informations relatives à un formulaire que l'Utilisateur a rempli sur le Site Internet et/ou l'Application (inscription ou accès à votre compte)
                  ou à des produits, services ou informations que l'Utilisateur a choisis sur le Site Internet et/ou l'Application (service souscrit, contenu consulté, etc …)
                </li>
              </ul>
              <div>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <strong>Site / Application</strong>
                      </td>
                      <td>
                        <strong>Partenaires&nbsp;&nbsp;</strong>
                      </td>
                      <td>
                        <strong>Plus d'informations&nbsp;&nbsp;</strong>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        seloger.com <br />
                        bellesdemeures.com <br />
                        selogerneuf.comseloger-construire.com <br />
                        seloger-bureaux-commerces.com
                      </td>
                      <td>XAMARIN&nbsp;&nbsp;</td>
                      <td>
                        permet de créer des applications en utilisant le langage C#.Ce traceur est strictement nécessaire pour le bon fonctionnement du Site ou de l’Application.{' '}
                        <a href="https://docs.microsoft.com/fr-fr/xamarin/get-started/what-is-xamarin" target="_blank" rel="noopener noreferrer">
                          https://docs.microsoft.com/fr-fr/xamarin/get-started/what-is-xamarin
                        </a>
                        &nbsp;&nbsp;
                      </td>
                    </tr>
                    <tr>
                      <td>
                        seloger.com <br />
                        bellesdemeures.com <br />
                        selogerneuf.comseloger-construire.com <br />
                        seloger-bureaux-commerces.com
                      </td>
                      <td>DATADOME&nbsp;&nbsp;</td>
                      <td>
                        permet d’assurer la sécurité de nos services en détectant/retraçant les tentatives de malveillance ou intrusions informatiquesCe traceur est strictement
                        nécessaire pour le bon fonctionnement du Site ou de l’Application.&nbsp;
                        <a href="https://datadome.co/fr/bot-protection/" target="_blank" rel="noopener noreferrer">
                          https://datadome.co/fr/bot-protection/
                        </a>
                        &nbsp;&nbsp;
                      </td>
                    </tr>
                    <tr>
                      <td>
                        seloger.com <br />
                        bellesdemeures.com <br />
                        selogerneuf.comseloger-construire.com <br />
                        seloger-bureaux-commerces.com
                      </td>
                      <td>Usercentrics&nbsp;&nbsp;</td>
                      <td>
                        permet d'enregistrer vos préférences en matière de traceurs.&nbsp;Ce traceur est strictement nécessaire pour le bon fonctionnement du Site ou de
                        l’Application.&nbsp;
                        <a href="https://usercentrics.com/" target="_blank" rel="noopener noreferrer">
                          https://usercentrics.com/
                        </a>
                        &nbsp;&nbsp;
                      </td>
                    </tr>
                    <tr>
                      <td>
                        seloger.com <br />
                        seloger-construire.com
                      </td>
                      <td>MAPBOX&nbsp;&nbsp;</td>
                      <td>
                        permet l’affichage d’une cartographie en ligneCe traceur est strictement nécessaire pour le bon fonctionnement du Site ou de l’Application.&nbsp;
                        <a href="https://www.mapbox.com/legal/privacy/" target="_blank" rel="noopener noreferrer">
                          https://www.mapbox.com/legal/privacy/
                        </a>
                        &nbsp;&nbsp;
                      </td>
                    </tr>
                    <tr>
                      <td>seloger.com</td>
                      <td>LAUNCHDARKLY&nbsp;&nbsp;</td>
                      <td>
                        permet de réaliser des AB/TESTS sur différentes versions du Site ou de l’Application.Ce traceur est strictement nécessaire pour le bon fonctionnement du
                        Site ou de l’Application.&nbsp;
                        <a href="https://launchdarkly.com/policies/privacy" target="_blank" rel="noopener noreferrer">
                          https://launchdarkly.com/policies/privacy
                        </a>
                        &nbsp;&nbsp;
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <h2>
                <strong>b) Les cookies de recommandations d'annonces personnalisées</strong>
              </h2>
              <p>Ces cookies que nous déposons permettent de vous adresser des recommandations d'annonces en lien avec votre navigation sur le Site ou l'Application.</p>
              <div>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <strong>Site / Application</strong>
                      </td>
                      <td>
                        <strong>Partenaires&nbsp;&nbsp;</strong>
                      </td>
                      <td>
                        <strong>Plus d'informations&nbsp;&nbsp;</strong>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        seloger.com <br />
                        selogerneuf.com
                      </td>
                      <td>SNOWPLOW&nbsp;&nbsp;</td>
                      <td>
                        permet d’envoyer les informations nécessaires à la recommandation d'annonce sur l’Application&nbsp;
                        <a href="https://snowplowanalytics.com/privacy-policy/" target="_blank" rel="noopener noreferrer">
                          https://snowplowanalytics.com/privacy-policy/
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <h2 style={{ textAlign: 'justify' }}>
                <strong>c) Les cookies de mesure d’audience</strong>
              </h2>
              <p style={{ textAlign: 'justify' }}>Ces cookies que nous déposons permettent :</p>
              <ul>
                <li>d'établir des statistiques anonymes de fréquentation du Site et de l'Application sauf opposition de votre part,</li>
                <li>de mesurer l'audience du site,</li>
                <li>de réaliser des études de marchés et améliorer notre site.</li>
              </ul>
              <div>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <strong>Site / Application</strong>
                      </td>
                      <td>
                        <strong>Partenaires&nbsp;&nbsp;</strong>
                      </td>
                      <td>
                        <strong>Plus d'informations&nbsp; / Mesure d’opposition</strong>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        seloger.com <br />
                        edito.seloger.com <br />
                        bellesdemeures.com <br />
                        selogerneuf.com <br />
                        seloger-construire.com <br />
                        seloger-bureaux-commerces.com
                      </td>
                      <td>AT INTERNET&nbsp;</td>
                      <td>
                        permet&nbsp; d’analyser et mesurer le comportement des Utilisateurs.&nbsp;
                        <a href="http://www.xiti.com/fr/optout.aspx" target="_blank" rel="noopener noreferrer">
                          http://www.xiti.com/fr/optout.aspx
                        </a>
                        &nbsp;&nbsp;
                      </td>
                    </tr>
                    <tr>
                      <td>
                        seloger.com <br />
                        bellesdemeures.com
                      </td>
                      <td>REALYTICS</td>
                      <td>
                        permet la mesure d'audience et statistiques, il est de ce fait exempt de consentement selon la CNIL&nbsp;
                        <a href="https://www.cnil.fr/fr/solutions-pour-les-cookies-de-mesure-daudience" target="_blank" rel="noopener noreferrer">
                          https://www.cnil.fr/fr/solutions-pour-les-cookies-de-mesure-daudience
                        </a>
                        , utilisé pour mesurer la performance des campagnes TV des annonceurs sur le digital. En plus de la mesure, Realytics offre des solutions d'optimisation ou
                        de mesure d'audience avancée qui peuvent nécessiter de recueillir un consentement libre, explicite et non équivoque de l'Utilisateur. Realytics devient
                        alors un fournisseur de données pour les partenaires de l'annonceur, qui doit s'assurer de la conformité du partenaire opérant.Dans les 2 cas, le cookie
                        Realytics s'engage à respecter les données collectées et à ne collecter aucune donnée personnelle ou sensible et peut être désactivé depuis la page opt-out
                        de Realytics en cliquant ici :&nbsp;
                        <a href="https://www.realytics.io/optout/" target="_blank" rel="noopener noreferrer">
                          https://www.realytics.io/optout/
                        </a>
                        <span style={{ textDecoration: 'underline' }}>.</span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        bellesdemeures.com <br />
                        selogerneuf.com <br />
                        seloger-construire.com <br />
                        seloger-bureaux-commerces.com
                      </td>
                      <td>MÉDIAMÉTRIE</td>
                      <td>
                        permet de mesurer l'audience du Site Internet.&nbsp;
                        <a href="https://www.mediametrie.fr/fr/gestion-des-cookies" target="_blank" rel="noopener noreferrer">
                          https://www.mediametrie.fr/fr/gestion-des-cookies
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <h2>
                <strong>d) Les cookies de suivi et personnalisation de votre navigation</strong>
              </h2>
              <p style={{ textAlign: 'justify' }}>Ces cookies que nous déposons permettent :</p>
              <ul>
                <li>de simplifier vos recherches en conservant vos annonces sauvegardées et rubriques visitées,</li>
                <li>de tester différentes versions du Site/de l'Application et mesurer l'audience de ces versions,</li>
                <li>
                  d'estimer automatiquement le degré d'intérêt de votre recherche et communiquer cette indication au professionnel de l'immobilier que vous contactez pour l'aider à
                  améliorer sa gestion des demandes de contact, lui permettre de mieux comprendre votre projet immobilier d'achat et lui indiquer les annonces qui pourraient vous
                  intéresser,
                </li>
                <li>de vous proposer des annonces correspondant à vos recherches précédentes.</li>
                <li>d’améliorer votre expérience utilisateur.</li>
              </ul>
              <div>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <strong>Site / Application</strong>
                      </td>
                      <td>
                        <strong>Partenaires&nbsp;&nbsp;</strong>
                      </td>
                      <td>
                        <strong>Plus d'informations&nbsp; / Mesure d’opposition</strong>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        seloger.com <br />
                        edito.seloger.com <br />
                        bellesdemeures.com <br />
                        selogerneuf.com <br />
                        seloger-construire.com <br />
                        seloger-bureaux-commerces.com
                      </td>
                      <td>GOOGLE ANALYTICS</td>
                      <td>
                        permet de gérer la publicité et d'analyser le comportement des Utilisateurs du Site Internet et de l'Application{' '}
                        <a href="https://policies.google.com/privacy?hl=fr&gl=fr" target="_blank" rel="noopener noreferrer">
                          https://policies.google.com/privacy?hl=fr&amp;gl=fr
                        </a>{' '}
                        <a
                          href="https://chrome.google.com/webstore/detail/google-analytics-opt-out/fllaojicojecljbmefodhfapmkghcbnh?hl=fr"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          https://chrome.google.com/webstore/detail/google-analytics-opt-out/fllaojicojecljbmefodhfapmkghcbnh?hl=fr
                        </a>{' '}
                        <a href="https://policies.google.com/technologies/cookies?hl=fr&gl=fr" target="_blank" rel="noopener noreferrer">
                          https://policies.google.com/technologies/cookies?hl=fr&amp;gl=fr
                        </a>{' '}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        seloger.com <br />
                        bellesdemeures.com <br />
                        selogerneuf.com <br />
                        seloger-construire.com <br />
                        seloger-bureaux-commerces.com
                      </td>
                      <td>HARVEST</td>
                      <td>
                        (déposé par DCF) afin de comprendre et analyser votre navigation.Pour vous opposer à ces cookies, désactivez la fonctionnalité Suivi et personnalisation de
                        votre navigation au sein de notre plateforme de gestion des cookies.
                      </td>
                    </tr>
                    <tr>
                      <td>
                        seloger.com <br />
                        bellesdemeures.com <br />
                        selogerneuf.com <br />
                        seloger-construire.com <br />
                        seloger-bureaux-commerces.com
                      </td>
                      <td>FIREBASE</td>
                      <td>
                        permet de suivre et d'analyser les usages de l'Application{' '}
                        <a href="https://www.firebase.com/terms/privacy-policy.html" target="_blank" rel="noopener noreferrer">
                          https://www.firebase.com/terms/privacy-policy.html
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        seloger.com <br />
                        bellesdemeures.com <br />
                        seloger-construire.com <br />
                        selogerneuf.com <br />
                        seloger-bureaux-commerces.com
                      </td>
                      <td>SNOWPLOW</td>
                      <td>
                        permet de comprendre et d'analyser les résultats de performance de l'Application{' '}
                        <a href="https://snowplowanalytics.com/privacy-policy/" target="_blank" rel="noopener noreferrer">
                          https://snowplowanalytics.com/privacy-policy/
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        bellesdemeures.com <br />
                        selogerneuf.com <br />
                        seloger-construire.com <br />
                        seloger-bureaux-commerces.com
                      </td>
                      <td>KAMELEOON</td>
                      <td>
                        permet de gérer les tests A/B destinés à améliorer l'expérience utilisateur sur le Site Internet{' '}
                        <a href="https://www.kameleoon.com/fr/politique-confidentialite" target="_blank" rel="noopener noreferrer">
                          https://www.kameleoon.com/fr/politique-confidentialite
                        </a>
                        .
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <h2>
                <strong>e) Les cookies de publicité ciblée</strong>
              </h2>
              <p style={{ textAlign: 'justify' }}>Ces cookies permettent :</p>
              <ul>
                <li>
                  l’affichage d’offres promotionnelles et de publicités pertinentes et ciblées pour vous dans les emplacements publicitaires réservés à la publicité sur des sites
                  tiers
                </li>
                <li>de mesurer l’efficacité d’une campagne publicitaire sur le Site ou l’Application,</li>
                <li>de limiter l’affichage d’une publicité sur le Site ou l’Application.</li>
              </ul>
              <p>&nbsp;Ils peuvent être déposés, sous réserve de votre consentement :</p>
              <ul>
                <li>soit par DCF,</li>
                <li>soit par ses partenaires publicitaires référencés dans la liste “Voir nos partenaires“ de notre plateforme de gestion des cookies.</li>
              </ul>
              <p style={{ textAlign: 'justify' }}>
                L'émission et l'utilisation de cookies par des tiers sont soumises aux politiques de protection de la vie privée de ces tiers. A ce titre, nous vous invitons à
                consulter la politique de confidentialité de ces partenaires liés à ces cookies dont certaines sont disponibles ci-après.
              </p>
              <div>
                <table>
                  <tbody>
                    <tr>
                      <td>
                        <strong>Site / Application</strong>
                      </td>
                      <td>
                        <strong>Partenaires&nbsp;&nbsp;</strong>
                      </td>
                      <td>
                        <strong>Plus d'informations&nbsp; / Mesure d’opposition</strong>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        seloger.com <br />
                        bellesdemeures.com <br />
                        selogerneuf.com <br />
                        seloger-construire.com <br />
                        seloger-bureaux-commerces.com
                      </td>
                      <td>ACCENGAGE&nbsp;&nbsp;</td>
                      <td>
                        permet de gérer et d'analyser les campagnes de routage de notifications et de diffusion de bannières publicitaires in-app.&nbsp;
                        <a href="https://www.accengage.com/privacy-policy/" target="_blank" rel="noopener noreferrer">
                          https://www.accengage.com/privacy-policy/
                        </a>
                        &nbsp;&nbsp;
                      </td>
                    </tr>
                    <tr>
                      <td>
                        seloger.com <br />
                        edito.seloger.com <br />
                        bellesdemeures.com <br />
                        selogerneuf.com <br />
                        seloger-construire.com <br />
                        seloger-bureaux-commerces.com
                      </td>
                      <td>DOUBLECLICK FOR PUBLISHERS GOOGLE ADS GOOGLE ADSENSE GOOGLE TAG MANAGER </td>
                      <td>
                        permet de gérer la publicité et d'analyser le comportement des Utilisateurs du Site Internet et de l'Application.&nbsp;
                        <a href="https://support.google.com/dfp_premium/answer/2839090?hl=fr" target="_blank" rel="noopener noreferrer">
                          https://support.google.com/dfp_premium/answer/2839090?hl=fr
                        </a>
                        &nbsp;&nbsp;
                        <a href="https://policies.google.com/privacy?hl=fr&gl=fr" target="_blank" rel="noopener noreferrer">
                          https://policies.google.com/privacy?hl=fr&amp;gl=fr
                        </a>
                        &nbsp;&nbsp;
                        <a href="https://adssettings.google.com/authenticated?hl=fr" target="_blank" rel="noopener noreferrer">
                          https://adssettings.google.com/authenticated?hl=fr
                        </a>
                        &nbsp;&nbsp;
                        <a href="https://policies.google.com/technologies/cookies?hl=fr&gl=fr" target="_blank" rel="noopener noreferrer">
                          https://policies.google.com/technologies/cookies?hl=fr&amp;gl=fr
                        </a>
                        <a href="https://support.google.com/tagmanager/answer/6102821?hl=fr" target="_blank" rel="noopener noreferrer">
                          https://support.google.com/tagmanager/answer/6102821?hl=fr
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        bellesdemeures.com <br />
                        selogerneuf.com <br />
                        seloger-construire.com <br />
                        seloger-bureaux-commerces.com
                      </td>
                      <td>REMAILME (CLOUDMEDIA) </td>
                      <td>
                        permet de proposer des publicités personnalisées affichant des produits ou services basées sur le comportement récent des internautes sur les sites,
                        newsletters et applications des partenaires de Remailme. Remailme reconnaît les internautes à l'aide de cookies.&nbsp;
                        <a href="https://remailme.fr/opt-out/" target="_blank" rel="noopener noreferrer">
                          https://remailme.fr/opt-out/
                        </a>
                        &nbsp;&nbsp;
                        <a href="https://www.cloudmedia.fr/vie-privee" target="_blank" rel="noopener noreferrer">
                          https://www.cloudmedia.fr/vie-privee
                        </a>
                        &nbsp;&nbsp;
                      </td>
                    </tr>
                    <tr>
                      <td>seloger.com</td>
                      <td>WEBORAMA&nbsp;&nbsp;</td>
                      <td>
                        afin que les publicités apparaissant sur le Site Internet et/ou l'application, ou d'autres sites, soient les plus pertinentes possible, Weborama collecte,
                        rapproche et analyse des informations pseudonymes issues de votre navigation sur le Site ou l'Application, à l'aide d'une ligne de code insérée dans les
                        pages que vous visitez (Tag Weborama). Le Tag Weborama permet également de limiter le nombre de fois vous voyez une publicité sur notre Site et de mesurer
                        l'efficacité d'une campagne publicitaire. Le Tag Weborama et les autres identifiants placés dans les cookies utilisés par Weborama, sont associés entre eux
                        pour chaque périphérique sur lequel vous vous connectez. Ces données sont croisées avec des données de navigation et rendues pseudonymes avant toute
                        utilisation par Weborama, aux fins de dresser votre profil d'Utilisateur et y associer des centres d'intérêts à partir desquels des publicités seront
                        servies pour le compte de partenaires annonceurs. Ces collectes et associations sont effectuées dans des conditions permettant d'assurer votre pseudonymat,
                        aucune donnée ne permettant à Weborama de vous identifier directement. Les données pseudonymes recueillies via le Tag Weborama sont conservées par Weborama
                        pour un maximum de 13 mois à partir de la date de la collecte.Vous pouvez désactiver la réception de publicités personnalisées sur ce lien&nbsp;
                        <a href="https://weborama.com/fr/opt-out-2/" target="_blank" rel="noopener noreferrer">
                          https://weborama.com/fr/opt-out-2/
                        </a>
                        &nbsp;&nbsp;
                      </td>
                    </tr>
                    <tr>
                      <td>
                        seloger.com <br />
                        bellesdemeures.com <br />
                        selogerneuf.com <br />
                        seloger-construire.com <br />
                        seloger-bureaux-commerces.com
                      </td>
                      <td>MEDIARITHMICS&nbsp;&nbsp;</td>
                      <td>
                        permet de suivre les interactions des Utilisateurs mobile afin d’améliorer la connaissance de l'Utilisateur, constituer des segments d'audience utilisateur
                        en fonction des comportements observés, améliorer l'expérience de l'utilisateur sur le site, personnaliser les plans marketing relationnels et personnaliser
                        les ciblages publicitaires&nbsp;
                        <a href="https://www.mediarithmics.com/fr-fr/content/charte-de-protection-des-donnees-personnelles" target="_blank" rel="noopener noreferrer">
                          https://www.mediarithmics.com/fr-fr/content/charte-de-protection-des-donnees-personnelles
                        </a>
                        &nbsp;&nbsp;
                      </td>
                    </tr>
                    <tr>
                      <td>
                        seloger.com <br />
                        edito.seloger.com <br />
                        bellesdemeures.com <br />
                        selogerneuf.com <br />
                        seloger-construire.com <br />
                        seloger-bureaux-commerces.com
                      </td>
                      <td>ADOBE EXPERIENCE</td>
                      <td>
                        permet de mesurer notre audience et de proposer aux Utilisateurs des expériences plus pertinentes et des messages marketing basés sur vos centres d’intérêt
                        potentiels&nbsp;
                        <a href="https://www.adobe.com/fr/privacy/opt-out.html#end-users" target="_blank" rel="noopener noreferrer">
                          https://www.adobe.com/fr/privacy/opt-out.html#end-users
                        </a>
                        .
                      </td>
                    </tr>
                    <tr>
                      <td>
                        seloger.com
                        <br />
                        edito.seloger.com
                      </td>
                      <td>YOUTUBE</td>
                      <td>
                        permet la lecture de vidéos sur le Site ou l’Application&nbsp;
                        <a href="https://policies.google.com/technologies/cookies?hl=fr" target="_blank" rel="noopener noreferrer">
                          https://policies.google.com/technologies/cookies?hl=fr
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        bellesdemeures.com <br />
                        selogerneuf.com <br />
                        seloger-construire.com <br />
                        seloger-bureaux-commerces.com
                      </td>
                      <td>CRASHLYTICS</td>
                      <td>
                        permet de collecter des données concernant l'utilisation de l'Application, notamment en ce qui concerne les pannes et les bugs du système. Les informations
                        sur l'appareil utilisé ou la version de l'Application installée, ainsi que d'autres informations seront utilisées afin d'aider à corriger les bugs,
                        principalement en ce qui concerne le logiciel et le matériel de l'Utilisateur.&nbsp;
                        <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
                          https://policies.google.com/privacy
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        bellesdemeures.com
                        <br />
                        selogerneuf.com
                        <br />
                        seloger-construire.com
                        <br />
                        seloger-bureaux-commerces.com
                      </td>
                      <td>TUNE</td>
                      <td>
                        permet de comprendre et d'analyser les résultats de performance de l'Application.&nbsp;
                        <a href="https://www.tune.com/resources/data-and-privacy/privacy-policies" target="_blank" rel="noopener noreferrer">
                          https://www.tune.com/resources/data-and-privacy/privacy-policies
                        </a>
                        .
                      </td>
                    </tr>
                    <tr>
                      <td>
                        seloger.com <br />
                        edito.seloger.com <br />
                        bellesdemeures.com <br />
                        selogerneuf.com <br />
                        seloger-construire.com <br />
                        seloger-bureaux-commerces.com
                      </td>
                      <td>CRITEO&nbsp;&nbsp;</td>
                      <td>
                        permet de réaliser du reciblage publicitaire auprès des Utilisateurs et optimiser les campagnes publicitaires&nbsp;
                        <a href="https://www.criteo.com/fr/privacy/" target="_blank" rel="noopener noreferrer">
                          https://www.criteo.com/fr/privacy/
                        </a>
                        &nbsp;&nbsp;
                      </td>
                    </tr>
                    <tr>
                      <td>seloger.com</td>
                      <td>APPSFLYER&nbsp;&nbsp;</td>
                      <td>
                        Permet l'analyse et le bon fonctionnement des campagne de publicités payantes sur l’application SeLoger&nbsp;
                        <a href="https://www.appsflyer.com/services-privacy-policy/" target="_blank" rel="noopener noreferrer">
                          https://www.appsflyer.com/services-privacy-policy/
                        </a>
                        &nbsp;&nbsp;
                      </td>
                    </tr>
                    <tr>
                      <td>seloger.com</td>
                      <td>NEXITY&nbsp; / TABOOLA</td>
                      <td>
                        permet la collecte de données sur les visiteurs de l’espace NEXITY pour reciblage publicitaire sur d’autres sites&nbsp;
                        <a href="https://www.nexity.fr/charte-de-protection-des-donnees/" target="_blank" rel="noopener noreferrer">
                          https://www.nexity.fr/charte-de-protection-des-donnees/
                        </a>
                        <a href="https://www.taboola.com/fr/policies/privacy-policy-fr" target="_blank" rel="noopener noreferrer">
                          https://www.taboola.com/fr/policies/privacy-policy-fr/
                        </a>
                        &nbsp;&nbsp;
                      </td>
                    </tr>
                    <tr>
                      <td>
                        seloger.com <br />
                        bellesdemeures.com <br />
                        selogerneuf.com <br />
                        seloger-construire.com <br />
                        seloger-bureaux-commerces.com
                      </td>
                      <td>TABOOLA&nbsp;&nbsp;</td>
                      <td>
                        permet la la collecte de données sur les visiteurs d’une page précise pour reciblage publicitaire sur d’autres sites&nbsp;
                        <a href="https://www.taboola.com/fr/policies/privacy-policy-fr" target="_blank" rel="noopener noreferrer">
                          https://www.taboola.com/fr/policies/privacy-policy-fr/
                        </a>
                        &nbsp;&nbsp;
                      </td>
                    </tr>
                    <tr>
                      <td>
                        bellesdemeures.com <br />
                        seloger-construire.com
                      </td>
                      <td>HOTJAR</td>
                      <td>
                        afin de mesurer et analyser le comportement des Utilisateurs&nbsp;
                        <a href="https://www.hotjar.com/privacy/do-not-track/" target="_blank" rel="noopener noreferrer">
                          https://www.hotjar.com/privacy/do-not-track/
                        </a>
                        .
                      </td>
                    </tr>
                    <tr>
                      <td>
                        seloger.com <br />
                        bellesdemeures.com <br />
                        selogerneuf.com <br />
                        <a href="http://www.seloger-construire.com" target="_blank" rel="noopener noreferrer">
                          seloger-construire.com
                        </a>{' '}
                        <br />
                        seloger-bureaux-commerces.com
                      </td>
                      <td>OUTBRAIN</td>
                      <td>
                        afin de générer un profil de centres d’intérêts et d’afficher de la publicité ciblée&nbsp;
                        <a href="https://my.outbrain.com/recommendations-settings/home" target="_blank" rel="noopener noreferrer">
                          https://my.outbrain.com/recommendations-settings/home
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        seloger.com <br />
                        bellesdemeures.com <br />
                        selogerneuf.com <br />
                        <a href="http://www.seloger-construire.com" target="_blank" rel="noopener noreferrer">
                          seloger-construire.com
                        </a>
                        &nbsp;
                        <br />
                        seloger-bureaux-commerces.com
                      </td>
                      <td>SMART AD SERVER</td>
                      <td>
                        permet d’héberger et gérer l’affichage de la publicité ciblée aux Utilisateurs&nbsp;
                        <a href="https://smartadserver.fr/politique-confidentialite-client-final/" target="_blank" rel="noopener noreferrer">
                          https://smartadserver.fr/politique-confidentialite-client-final/
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        seloger-construire.com
                        <br />
                        seloger-bureaux-commerces.com
                      </td>
                      <td>APPNEXUS</td>
                      <td>
                        permet de mettre en relation les vendeurs et les acheteurs d’espaces publicitaires via une plateforme automatisée{' '}
                        <a href="https://www.appnexus.com/platform-privacy-policy-fr-072016" target="_blank" rel="noopener noreferrer">
                          https://www.appnexus.com/platform-privacy-policy-fr-072016
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <h2 style={{ textAlign: 'justify' }}>f) Connexion via les réseaux sociaux</h2>
              <p style={{ textAlign: 'justify' }}>
                DCF est susceptible d'inclure sur le Site Internet, des applications informatiques émanant de tiers, qui permettent à l'Utilisateur de partager des contenus du Site
                Internet avec d'autres personnes ou de faire connaître à ces autres personnes sa consultation ou son opinion concernant un contenu du Site Internet. Tel est
                notamment le cas des boutons « Partager », « J'aime », issus de réseaux sociaux tels que « Facebook » « Twitter », « LinkedIn », etc.
              </p>
              <p style={{ textAlign: 'justify' }}>
                Le réseau social fournissant un tel bouton applicatif est susceptible d'identifier l'Utilisateur grâce à ce bouton, même s'il n’a pas utilisé ce bouton lors de sa
                consultation du Site Internet. En effet, ce type de bouton applicatif peut permettre au réseau social concerné de suivre la navigation de l'Utilisateur sur le Site
                Internet, du seul fait que son compte au réseau social concerné était activé sur son terminal (session ouverte) durant sa navigation sur le Site Internet.
              </p>
              <p style={{ textAlign: 'justify' }}>
                Si l'Utilisateur ne souhaite pas que les réseaux sociaux publient ses actions issues des plug-ins dans ses comptes sur les réseaux sociaux, l'Utilisateur doit se
                déconnecter de ses réseaux sociaux avant de naviguer sur le Site Internet.
              </p>
              <h2 style={{ textAlign: 'justify' }}>3. Comment paramétrer mes cookies ?</h2>
              <p>Plusieurs possibilités sont offertes pour gérer les cookies.</p>
              <p style={{ textAlign: 'justify' }}>
                A tout moment, lorsque vous le souhaitez, vous avez la possibilité de contrôler vos souhaits en matière de cookies
                <strong> en paramétrant le module de cookies dont le lien est accessible en bas de page du Site ou dans les menus de l'Application.</strong>
              </p>
              <p style={{ textAlign: 'justify' }}>Vous pouvez également gérer les cookies:</p>
              <p style={{ textAlign: 'justify' }}>
                <strong>1) en paramétrant le module de cookies dont le lien est accessible en bas de page du Site.</strong>
              </p>
              <p style={{ textAlign: 'justify' }}>
                <strong>2) en paramétrant votre navigateur :</strong>
              </p>
              <p style={{ textAlign: 'justify' }}>
                L'Utilisateur peut configurer son logiciel de navigation de manière à ce que des cookies soient enregistrés dans son terminal ou, au contraire, qu'ils soient
                rejetés, soit systématiquement, soit selon leur émetteur.&nbsp;
              </p>
              <p style={{ textAlign: 'justify' }}>
                L'Utilisateur peut également configurer son logiciel de navigation de manière à ce que l'acceptation ou le refus des cookies lui soient proposés ponctuellement,
                avant qu'un cookie soit susceptible d'être enregistré dans son terminal.
              </p>
              <p style={{ textAlign: 'justify' }}>
                Pour la gestion des cookies et des choix de l'Utilisateur, la configuration de chaque navigateur est différente. Elle est décrite dans le menu d'aide du navigateur
                de l'Utilisateur, qui lui permettra de savoir de quelle manière modifier ses souhaits en matière de cookies.
              </p>
              <p style={{ textAlign: 'justify' }}>
                Pour plus d'information :
                <a href="http://www.cnil.fr/vos-droits/vos-traces/les-cookies/conseils-aux-internautes/" target="_blank" rel="noopener noreferrer">
                  http://www.cnil.fr/vos-droits/vos-traces/les-cookies/conseils-aux-internautes/
                </a>
              </p>
              <p style={{ textAlign: 'justify' }}>Par exemple :</p>
              <p style={{ textAlign: 'justify' }}>
                - Pour Internet Explorer :{' '}
                <a href="http://windows.microsoft.com/fr-FR/windows-vista/Block-or-allow-cookies" target="_blank" rel="noopener noreferrer">
                  http://windows.microsoft.com/fr-FR/windows-vista/Block-or-allow-cookies
                </a>
              </p>
              <p style={{ textAlign: 'justify' }}>
                - Pour Firefox :{' '}
                <a href="https://support.mozilla.org/fr/kb/activer-desactiver-cookies-preferences" target="_blank" rel="noopener noreferrer">
                  https://support.mozilla.org/fr/kb/activer-desactiver-cookies-preferences
                </a>
              </p>
              <p style={{ textAlign: 'justify' }}>
                - Pour Safari :{' '}
                <a href="https://support.apple.com/fr-fr/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">
                  https://support.apple.com/fr-fr/guide/safari/sfri11471/mac
                </a>
              </p>
              <p style={{ textAlign: 'justify' }}>
                - Pour Google Chrome :{' '}
                <a href="https://support.google.com/chrome/answer/95647?hl=fr&hlrm=en" target="_blank" rel="noopener noreferrer">
                  https://support.google.com/chrome/answer/95647?hl=fr&amp;hlrm=en
                </a>
              </p>
              <p style={{ textAlign: 'justify' }}>
                - Pour Opera™ :{' '}
                <a href="http://help.opera.com/Windows/10.20/fr/cookies.html" target="_blank" rel="noopener noreferrer">
                  http://help.opera.com/Windows/10.20/fr/cookies.html
                </a>
                ,
              </p>
              <p style={{ textAlign: 'justify' }}>- Etc …</p>
              <p style={{ textAlign: 'justify' }}>- Les cookies « Flash »© de « Adobe Flash Player »™</p>
              <p style={{ textAlign: 'justify' }}>
                « Adobe Flash Player »™ est une application informatique qui permet le développement rapide des contenus dynamiques utilisant le langage informatique « Flash ».
                Flash(et les applications de même type) mémorise les paramètres, les préférences et l'utilisation de ces contenus grâce à une technologie similaire aux cookies.
                Toutefois, « Adobe Flash Player »™ gère ces informations et vos choix via une interface différente de celle fournie par votre logiciel de navigation.
              </p>
              <p style={{ textAlign: 'justify' }}>
                Dans la mesure où le terminal de l'Utilisateur serait susceptible de visualiser des contenus développés avec le langage Flash, l'Utilisateur est invité à accéder à
                ses outils de gestion des cookies Flash, directement depuis le&nbsp;
                <a href="https://www.adobe.com/fr/privacy/cookies.html" target="_blank" rel="noopener noreferrer">
                  https://www.adobe.com/fr/privacy/cookies.html
                </a>
              </p>
              <p style={{ textAlign: 'justify' }}>
                <strong>3)&nbsp; en refusant les cookies publicitaires via youronlinechoices.com</strong>
              </p>
              <p style={{ textAlign: 'justify' }}>
                L'Utilisateur peut gérer l'utilisation et l'exploitation des cookies en se rendant sur la plateforme de gestion des cookies publicitaires proposée par les
                professionnels de la publicité accessible à l'adresse :&nbsp;
                <a href="http://www.youronlinechoices.com/fr/controler-ses-cookies/" target="_blank" rel="noopener noreferrer">
                  http://www.youronlinechoices.com/fr/controler-ses-cookies/
                </a>
                et en suivant les instructions qui y sont données. L'Utilisateur pourra ainsi connaître les entreprises inscrites à cette plateforme, lesquelles leur offrent la
                possibilité de refuser ou accepter les cookies utilisés par elles pour adapter à leurs informations de navigation, les publicités susceptibles d'être affichées.
              </p>
              <p style={{ textAlign: 'justify' }}>
                <strong>4) en refusant un cookie émis par un réseau social :</strong>
              </p>
              <p style={{ textAlign: 'justify' }}>
                Si l'Utilisateur ne souhaite pas que le Site Internet et/ou l'Application enregistre des cookies émis par un réseau social, l'Utilisateur peut cliquer sur les liens
                d'information suivants afin de désactiver les cookies émis par un réseau social. Désactiver ces cookies empêchera donc toute interaction avec le ou les réseaux
                sociaux concernés :
              </p>
              <p style={{ textAlign: 'justify' }}>
                FACEBOOK :&nbsp;
                <a href="https://fr-fr.facebook.com/policies/cookies/" target="_blank" rel="noopener noreferrer">
                  https://fr-fr.facebook.com/policies/cookies/
                </a>
              </p>
              <p style={{ textAlign: 'justify' }}>
                TWITTER :&nbsp;
                <a href="https://support.twitter.com/articles/20171379-twitter-prend-en-charge-la-desactivation-du-suivi-dnt" target="_blank" rel="noopener noreferrer">
                  https://support.twitter.com/articles/20171379-twitter-prend-en-charge-la-desactivation-du-suivi-dnt#
                </a>
              </p>
              <p style={{ textAlign: 'justify' }}>
                GOOGLE + :&nbsp;
                <a href="https://support.google.com/accounts/answer/3118621?hl=fr" target="_blank" rel="noopener noreferrer">
                  https://support.google.com/accounts/answer/3118621?hl=fr
                </a>
              </p>
              <p style={{ textAlign: 'justify' }}>
                LINKEDIN :&nbsp;
                <a href="http://www.linkedin.com/legal/cookie-policy" target="_blank" rel="noopener noreferrer">
                  http://www.linkedin.com/legal/cookie-policy
                </a>
              </p>
              <p style={{ textAlign: 'justify' }}>
                YAHOO :&nbsp;
                <a href="https://info.yahoo.com/privacy/us/yahoo/cookies/" target="_blank" rel="noopener noreferrer">
                  https://info.yahoo.com/privacy/us/yahoo/cookies/
                </a>
              </p>
              <p style={{ textAlign: 'justify' }}>
                YOUTUBE :&nbsp;
                <a href="https://support.google.com/accounts/answer/3118621?hl=fr" target="_blank" rel="noopener noreferrer">
                  https://support.google.com/accounts/answer/3118621?hl=fr
                </a>
              </p>
              <p style={{ textAlign: 'justify' }}>
                En savoir plus sur les cookies&nbsp;
                <a href="https://www.cnil.fr/fr/cookies-et-traceurs-que-dit-la-loi" target="_blank" rel="noopener noreferrer">
                  https://www.cnil.fr/fr/cookies-et-traceurs-que-dit-la-loi
                </a>
              </p>
              <p style={{ textAlign: 'justify' }}>
                En cas de refus de certains traceurs, les fonctionnalités associées aux traceurs refusés ne seront pas accessibles (par exemple : la recommandation ou la
                personnalisation du service).&nbsp;
              </p>
              <p style={{ textAlign: 'justify' }}>
                Le cas échéant, DCF décline toute responsabilité pour les conséquences liées au fonctionnement dégradé de ses services résultant des choix exprimés par
                l'utilisateur.
              </p>
              <p style={{ textAlign: 'justify' }}>
                &nbsp;En tout état de cause, les fonctionnalités strictement nécessaires ou demandées par l'utilisateur resteront accessibles (par exemple : l'authentification à un
                compte et la mise en favoris).
              </p>
              <p style={{ textAlign: 'justify' }}>
                <strong>4. Durée de conservation de vos choix</strong>
              </p>
              <p style={{ textAlign: 'justify' }}>Vos choix en matière de cookies sont conservés au maximum pour une durée de 6 (six) mois.</p>
            </div>
          </div>
        </div>
      </div>
    </Container>
  )
}

export default DataPrivacy
